import Button from '@/components/Button';
import { useGameTeaser, type GameTeaserProps } from '@/components/GameTeaser';
import LinkWrapper from '@/components/LinkWrapper';
import classnames from '@/utilities/classnames';
import replaceAbbreviations from '@/utilities/replaceAbbreviations';
import Image from 'next/image';

export default function NavigationGameTeaser(
  props: GameTeaserProps<{
    link: string;
  }>
) {
  const { config, state, theme } = useGameTeaser(props);
  // Rubbellose?
  const subtitle = props.game === 11 ? '' : state.subtitle;
  const jackpot =
    props.game === 11 ? config?.jackpotOfflineDescGame : state.jackpot;

  return config ? (
    <div
      className={classnames(
        'NavigationGameTeaser',
        `NavigationGameTeaser--${theme}`,
        {
          'NavigationGameTeaser--alternative': !!config.alternativeDesign,
        }
      )}
    >
      <header className="NavigationGameTeaser__header">
        <span
          className="NavigationGameTeaser__subtitle"
          dangerouslySetInnerHTML={replaceAbbreviations(subtitle)}
        />
        <strong
          className="NavigationGameTeaser__jackpot"
          dangerouslySetInnerHTML={replaceAbbreviations(jackpot || '')}
        />
        {props.link && props.link !== '#' && (
          <small
            className="NavigationGameTeaser__chance"
            dangerouslySetInnerHTML={replaceAbbreviations(config.chanceDesc)}
          />
        )}
      </header>
      {props.link && props.link !== '#' && (
        <LinkWrapper
          className="NavigationGameTeaser__link"
          tabIndex={0}
          href={props.link}
        >
          <Button variant={config.button} fullWidth={true} tabIndex={-1}>
            {config.title} spielen
          </Button>
        </LinkWrapper>
      )}

      {theme === 'lotto6aus49' && (
        <div className="NavigationGameTeaser__image">
          <Image
            alt="Lotto 6aus49 - das Original"
            src="/assets/images/lotto-6aus49-campaign-2026-stamp.webp"
            className="Footer__image"
            loading="lazy"
            width={253}
            height={0}
          />
        </div>
      )}
    </div>
  ) : null;
}
